import { Injectable } from '@angular/core';
import { AdminOrdersService } from '../../orders/admin-orders.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class QoudsUtilService {

  constructor( private order: AdminOrdersService ) { }

  updateQouds(scope, orderId) {
    this.order.updateQoudInfo(orderId).subscribe(data => {
      scope.showAlertBox();
    }, error => {
      if (error?.error) {
        scope.successImg = false;
        scope.confirmMsg = 'حدث خطأ ما، الرجاء المحاولة لاحقاً';
        scope.showAlertBox();
      }
    });
  }

  createQoyoodInvoice(scope, orderId) {
    this.order.createQoyoodInvoice(orderId).subscribe(data => {
      scope.showAlertBox();
    }, error => {
      if (error?.error) {
        scope.successImg = false;
        scope.confirmMsg = 'حدث خطأ ما، الرجاء المحاولة لاحقاً';
        scope.showAlertBox();
      }
    });
  }
}
